const systemStatusCode = [
    {
        code: 404,
        message: 'Not Found',
        description: 'Nenhuma página no sistema foi endereçada para essa rota.',
    },
]

export default systemStatusCode